/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComplexAggregation
 */
export interface ComplexAggregation {
    /**
     * 
     * @type {number}
     * @memberof ComplexAggregation
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ComplexAggregation
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ComplexAggregation
     */
    image?: string | null;
}

export function ComplexAggregationFromJSON(json: any): ComplexAggregation {
    return ComplexAggregationFromJSONTyped(json, false);
}

export function ComplexAggregationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplexAggregation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'image': !exists(json, 'image') ? undefined : json['image'],
    };
}

export function ComplexAggregationToJSON(value?: ComplexAggregation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'image': value.image,
    };
}


